import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { getOpportunities, getOpportunity, getUserPostulation } from "../apis/opportunities.api";
import { useUser } from "./User";

interface ListOpportunities {
  userId: string;
}

export const useOpportunities = ({ userId }: ListOpportunities) => {
  const { data , ...rest } = useQuery("getOpportunities", async () => {
    const opportunities = await getOpportunities(userId);
    return opportunities;
  });

  const cleanData = data ? Object.keys(data).map((key) => data[key]) : [];
  return ({ ...rest, data: cleanData });
};

export const useOpportunity = () => {
  const { cid, oid } = useParams();
  const { id } = useUser().getDataAll();

  const requestUserPostulation = () => {
    if (id)
      return getUserPostulation(id, cid!, oid!);
    return {hasSubscription: false};
  }
  
  const requestOpportunityPageData = () => Promise.all([
    requestUserPostulation() , getOpportunity(cid!, oid!)
  ]);

  const { data: opportunityData, ...rest } = useQuery(
    "getOpportunity", requestOpportunityPageData
  );

  return { opportunityData, ...rest };
}